#import "../fragments/contact-basic.graphql"

mutation SelectCreateContact($input: ContactCreateInput!) {
    contactCreate(input: $input) {
        contact {
            ...ContactBasic
        }
    }
}
